import { analytics } from '@/common/analytics/analytics'
import { ANALYTICS_EVENTS } from '@/common/analytics/events'
import { Button, H1 } from '@/common/ui'
import useTradeModalStore from '@/trading/tradeModalStore'
import { useOrderSource } from '@/common/context/useOrderSource'
import { ORDER_ENTRY_POINT, ORDER_FROM } from '@/common/context/orderSourceValues'

type Props = {
    campaignId: string
    followersGoal: number
    targetCompaniesAsxCodes: string[]
    className?: string
}

export function TakeActionBox({ campaignId, followersGoal = 100, targetCompaniesAsxCodes, className }: Props) {
    const { setSecurityCodes, setOrderAction } = useTradeModalStore()
    const { setOrderSource } = useOrderSource()

    return (
        <aside className={`bg-primary w-full rounded-md p-20 text-white flex flex-col items-center ${className}`}>
            <H1 className="text-center">Take action</H1>
            <p className="text-center">
                Goal: Our target is to engage a minimum of {followersGoal} shareholders for each company, allowing us to
                draft resolutions before their AGMs. The greater the number of shareholders, the stronger our influence!
            </p>
            <p className="text-xs text-center mt-8 text-balance">
                The ASX sets an initial minimum buy-in of $500 for any company. The first time you buy shares in any
                company, you'll need to transfer in $500 + brokerage fees.
            </p>
            <p className="text-xs text-center mt-2">You own these shares outright until you sell them.</p>
            <Button
                onClick={() => {
                    setOrderSource(ORDER_FROM.CAMPAIGNS, ORDER_ENTRY_POINT.BUY_SHARES)
                    analytics.trackWithDefaults(ANALYTICS_EVENTS.CAMPAIGNS.CAMPAIGN_BUY_BUTTON_CLICKED, {
                        security_codes: targetCompaniesAsxCodes,
                        campaign_id: campaignId,
                    })
                    setSecurityCodes(targetCompaniesAsxCodes)
                    setOrderAction('BUY')
                }}
                className="mt-8"
                variant="secondary"
            >
                Buy shares
            </Button>
        </aside>
    )
}
